/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const CodeIcon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 16, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="CodeIcon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M6.01488 13.8787L5.99995 13.9384V14H7.01534L9.98502 2.12127L9.99995 2.06155V2H8.98456L6.01488 13.8787ZM2.70706 8L4.85351 10.1464L4.1464 10.8536L1.6464 8.35355L1.29285 8L1.6464 7.64645L4.1464 5.14645L4.85351 5.85355L2.70706 8ZM13.2928 8L11.1464 10.1464L11.8535 10.8536L14.3535 8.35355L14.7071 8L14.3535 7.64645L11.8535 5.14645L11.1464 5.85355L13.2928 8Z"
              fill="currentColor"
            />
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

CodeIcon.tags = ['bracket', 'build', 'code', 'development', 'programming'];

CodeIcon.category = 'General Icons';

CodeIcon.iconSize = 16;
